/* Landing banda — JS extraído de la fuente.
   Lo carga layout/landing.liquid (case 'banda'). */


(function(){
/* Contrato Shopify (literales para el publicador): __banda_SEL bandaTriggerCOD te_regalo */
var PRICES={1:74900,2:109900};
var COMPARE={1:119900,2:179900};
var BULLETS=['Pedales y mangos de espuma cómodos','Se usa de pie, sentada o acostada','Compacta: 47 × 23 cm, cabe en cualquier rincón','Tu primera rutina de 10 minutos, hoy mismo'];
var IMGS=[__A('ad-assets/prod-03.jpg'),__A('ad-assets/prod-06.jpg'),__A('ad-assets/prod-07.jpg'),__A('ad-assets/prod-04.jpg'),__A('ad-assets/prod-08.jpg')];
var WA='573505802167';
var st={qty:1};
function slug(){return 'banda'}
/* Releasit trae su propio selector de cantidad (radios quantity_offer): preseleccionar el combo elegido en la página */
function pickOffer(qty){function go(){var d=document.querySelector('dialog[open]');var r=d&&d.querySelector('input[name="quantity_offer"][value="quantity_'+(qty-1)+'"]');if(r){if(!r.checked)r.click();return true}return false}
 if(go())return;var mo=new MutationObserver(function(){if(go())mo.disconnect()});mo.observe(document.body,{childList:true,subtree:true});setTimeout(function(){mo.disconnect()},20000)}
function $(s){return document.querySelector(s)}
function V(p){return window.__A?window.__A(p):p} /* __A del tema: el publicador no envuelve .mp4 */
function fmt(n){return '$'+n.toString().replace(/\B(?=(\d{3})+(?!\d))/g,'.')}
function buildGallery(){
 var tr=$('#track'), th=$('#thumbs'), dots=$('#dots');
 tr.innerHTML=''; th.innerHTML=''; dots.innerHTML='';
 (function(){
  var sl=document.createElement('div'); sl.className='slide';
  var v=document.createElement('video'); v.muted=true; v.loop=true; v.autoplay=true; v.playsInline=true; v.setAttribute('playsinline',''); v.setAttribute('muted',''); v.preload='auto'; v.poster=__A('ad-assets/banda-atf-poster.jpg'); v.src=V('ad-assets/banda-atf.mp4');
  sl.appendChild(v); tr.appendChild(sl);
  var b=document.createElement('button'); b.type='button'; b.className='thumb'; b.setAttribute('aria-label','Ver video');
  var t=document.createElement('img'); t.alt=''; t.src=__A('ad-assets/banda-atf-poster.jpg'); b.appendChild(t);
  var pl=document.createElement('span'); pl.className='pl'; pl.textContent='▶'; b.appendChild(pl);
  b.onclick=function(){go(0)}; th.appendChild(b); dots.appendChild(document.createElement('i'));
 })();
 IMGS.forEach(function(src,j){var i=j+1;
  var sl=document.createElement('div'); sl.className='slide';
  var im=document.createElement('img'); im.alt='Banda Pedal '+(i+1); im.src=src; im.loading='lazy';
  sl.appendChild(im); tr.appendChild(sl);
  var b=document.createElement('button'); b.type='button'; b.className='thumb'; b.setAttribute('aria-label','Ver '+(i+1));
  var t=document.createElement('img'); t.alt=''; t.src=src; b.appendChild(t); b.onclick=function(){go(i)}; th.appendChild(b);
  dots.appendChild(document.createElement('i'));
 });
 tr.scrollLeft=0; mark(0);
}
function go(i){var tr=$('#track'); tr.scrollTo({left:i*tr.clientWidth,behavior:'smooth'})}
function mark(i){document.querySelectorAll('#thumbs .thumb').forEach(function(e,k){e.classList.toggle('on',k===i)});document.querySelectorAll('#dots i').forEach(function(e,k){e.classList.toggle('on',k===i)});var v=document.querySelector('#track video');if(v){if(i===0){var pr=v.play();if(pr&&pr.catch)pr.catch(function(){})}else v.pause()}}
(function(){var tr=document.getElementById('track'); var raf;
 tr.addEventListener('scroll',function(){cancelAnimationFrame(raf);raf=requestAnimationFrame(function(){mark(Math.round(tr.scrollLeft/tr.clientWidth))})},{passive:true});
 document.getElementById('prev').onclick=function(){var i=Math.round(tr.scrollLeft/tr.clientWidth);go(Math.max(0,i-1))};
 document.getElementById('next').onclick=function(){var i=Math.round(tr.scrollLeft/tr.clientWidth);go(Math.min(document.querySelectorAll('#track .slide').length-1,i+1))};
})();
function render(){
 $('#bullets').innerHTML=BULLETS.map(function(b){return '<li>'+b+'</li>'}).join('');
 $('#badge').textContent='-'+Math.round((1-PRICES[1]/COMPARE[1])*100)+'%';
 $('#bundles').innerHTML=[1,2].map(function(q){
  var p=PRICES[q], save=PRICES[1]*q-p;
  return '<button type="button" class="bundle'+(q===st.qty?' on':'')+'" data-qty="'+q+'">'+(q===2?'<span class="tag">MÁS POPULAR</span>':'')+
   '<span class="radio"></span><span class="t">'+q+(q===1?' banda':' bandas')+'<small>'+(q===1?'Precio de lanzamiento':'Ahorras '+fmt(save)+' · ≈ '+fmt(Math.round(p/q/100)*100)+' c/u')+'</small></span><span class="p">'+fmt(p)+'<s>'+fmt(COMPARE[q])+'</s></span></button>';
 }).join('');
 $('#finalPrice').innerHTML=fmt(PRICES[st.qty])+' <s>'+fmt(COMPARE[st.qty])+'</s>';
 $('#stTitle').textContent='Banda Pedal x'+st.qty; $('#stPrice').textContent=fmt(PRICES[st.qty]);
}
/* los combos solo seleccionan: el formulario lo abre únicamente el botón de compra */
document.addEventListener('click',function(e){
 var t=e.target.closest('.bundle'); if(t){st.qty=+t.dataset.qty;render();}
});
/* punto de compra único (Contrato Shopify) */
window.openOrder=function(){
 var on=document.querySelector('.bundle.on'); var qty=on?+on.dataset.qty:1;
 window['__'+slug()+'_SEL']={qty:qty};
 try{localStorage.setItem('te_regalo',slug()+'|'+Date.now())}catch(e){}
 if(window[slug()+'TriggerCOD']&&window[slug()+'TriggerCOD']()!==false){pickOffer(qty);return}
 var txt='Banda Pedal · '+qty+(qty===1?' unidad':' unidades')+' · '+fmt(PRICES[qty])+' (pago al recibir)';
 $('#modalTxt').textContent=txt;
 $('#modalWa').href='https://wa.me/'+WA+'?text='+encodeURIComponent('Hola, quiero pedir: '+txt);
 $('#modal').classList.add('on');
};
var sticky=$('#sticky');
function onScroll(){sticky.classList.toggle('show',window.scrollY>window.innerHeight*0.6)}
window.addEventListener('scroll',onScroll,{passive:true}); onScroll();
if('IntersectionObserver' in window){
 var io=new IntersectionObserver(function(es){es.forEach(function(e){if(!e.isIntersecting)return;e.target.classList.add('in');io.unobserve(e.target)})},{threshold:.18});
 document.querySelectorAll('.rv').forEach(function(e){io.observe(e)});
}else{document.querySelectorAll('.rv').forEach(function(e){e.classList.add('in')})}
var sv=document.querySelectorAll('.vids video,.demo video');
if(sv.length&&'IntersectionObserver' in window){var vo=new IntersectionObserver(function(es){es.forEach(function(e){var v=e.target;if(e.isIntersecting){var p=v.play();if(p&&p.catch)p.catch(function(){})}else v.pause()})},{threshold:.35});sv.forEach(function(v){vo.observe(v)})}
setInterval(function(){var b=document.querySelector('.hero-cta .btn');if(b){b.classList.remove('wig');void b.offsetWidth;b.classList.add('wig')}},7000);
buildGallery();
render();
})();

/* ============================================================
   Releasit COD — variante activa + cantidad + disparo del modal
   Lo genera tools/apply_cod_trigger.py desde tools/cod_trigger.js.tpl.

   PATRÓN:
   NO se crean variantes-bundle. Dropi solo despacha las variantes que
   mapeó al IMPORTAR el producto; una variante creada después por API
   queda huérfana y el pedido no le llega (bug real de producción).
   Por eso el bundle es la MISMA variante de Dropi con quantity = N, y el
   total lo baja un descuento automático de Shopify (mín. N unidades).
   Así el pedido lleva las unidades físicas reales y Dropi las despacha.

   Releasit lee la cantidad de input[name="quantity"] en el DOM al abrir,
   y la variante de window.productData — pero SOLO la re-lee si se hace
   click en su botón nativo. _rsiV2.setState abre el modal con la variante
   cacheada al init, así que queda como último recurso.
   Depende de quantityControlsHidden:true en Releasit (ya global): si el
   cliente pudiera bajar la cantidad, pagaría el precio con descuento por
   menos unidades.
   ============================================================ */
(function () {
  var RELEASIT_SELECTORS = [
    '#rsi_buy_now_button',
    '.rsi_buy_now_button',
    '._rsi-buy-now-button',
    '._rsi-buy-now-button-app-block-hook button',
    '._rsi-buy-now-button-app-block-hook a',
    '.rsi-btn-skel'
  ];

  function findReleasitButton() {
    for (var i = 0; i < RELEASIT_SELECTORS.length; i++) {
      var el = document.querySelector(RELEASIT_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function setVariantOnAllForms(variantId, qty) {
    if (!variantId) return;
    var q = parseInt(qty, 10);
    if (!q || q < 1) q = 1;
    document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (i) {
      i.value = variantId;
      i.setAttribute('value', variantId);
    });
    document.querySelectorAll('input[name="product-id"]').forEach(function (i) { i.value = variantId; });
    document.querySelectorAll('input[name="quantity"]').forEach(function (i) {
      i.value = String(q);
      i.setAttribute('value', String(q));
    });
    if (window.productData) { window.productData.quantity = q; }
    if (window.productData && Array.isArray(window.productData.variants)) {
      var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
      if (v) {
        window.productData.selected_or_first_available_variant = v;
        window.productData.selected_variant = v;
        try {
          document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
          document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
        } catch (e) {}
      }
    }
  }

  /* Qué variante y qué cantidad está eligiendo el cliente ahora mismo.
     Siempre se lee del DOM — nunca del SKU, que Dropi reescribe. */
  function qtyOf(s) {
    var q = parseInt(s && s.qty, 10);
    if (!q) { var on = document.querySelector('[data-qty].on, [data-qty].active, [data-qty][aria-checked="true"]');
      q = on ? parseInt(on.getAttribute('data-qty'), 10) : 1; }
    return q || 1;
  }
  function current() {
    var s = window.__banda_SEL || {};
    var V = window.BANDA_VARIANTS || [];
    var v = V.filter(function (x) { return x.available; })[0] || V[0];
    return v ? { id: v.id, qty: qtyOf(s) } : null;
  }

  function sync() {
    var s = current();
    if (s && s.id) setVariantOnAllForms(s.id, s.qty);
    return s;
  }

  // el JS de la landing ya mueve la clase activa; aquí solo re-leemos después
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.__banda-no-watch')) {
      setTimeout(sync, 0);
    }
  }, true);

  document.addEventListener('DOMContentLoaded', sync);
  sync();

  /* ¿Está abierto el modal de Releasit? (<dialog class="rsi-form-wrap"> con open) */
  function rsiOpen() {
    var d = document.querySelectorAll('dialog');
    for (var i = 0; i < d.length; i++) { if (d[i].open && /rsi/.test(String(d[i].className))) return true; }
    return false;
  }

  /* UN solo click debe abrir el formulario. Si el cliente toca antes de que Releasit termine de
     cargar (botón aún sin enganchar), el primer click se perdía y hacían falta dos: ahora se
     reintenta hasta confirmar que el modal abrió (máx. ~15 s). */
  window.bandaTriggerCOD = function () {
    var s = sync();
    if (!s || !s.id) return;
    if (window.banda_opening) clearInterval(window.banda_opening);
    var tries = 0;
    function attempt() {
      sync();
      var b = findReleasitButton();
      if (b) b.click();
      else if (tries > 20 && window._rsiV2 && typeof window._rsiV2.setState === 'function') {
        try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
      }
    }
    setTimeout(function () {
      attempt();
      window.banda_opening = setInterval(function () {
        tries++;
        if (rsiOpen() || tries > 18) { clearInterval(window.banda_opening); return; }
        attempt();
      }, 800);
    }, 50);
  };
})();
